import { Key } from "react";

type MenuListType = {
  [x: string]: Key | null | undefined;
  label: string;
  route: string;
  icon?: any;
};

export const MENU_LIST: MenuListType[] = [
  {
    label: "Home",
    route: "/home",
    icon: "home",
  },
  {
    label: "C-DAD",
    route: "/c-dad",
    icon: "cdad",
  },
  {
    label: "CANVA",
    route: "/canva",
    icon: "canva",
  }
];

//userguide updated on December 17 2024
export const userGuideDoc = "https://www.ascentt.com/"; 
export const veadsRequestAccess = `https://www.ascentt.com/`;

export const REDIRECT_URL = window.location.origin;


export const AGGREGATIONLIST = [
  { label: "Maximum Value", value: "max_value" },
  { label: "Minimum Value", value: "min_value" },
  { label: "Standard deviation", value: "std_value" },
  { label: "Average", value: "avg_value" },
];

export const headerDataTableHeaders = [
  {
    label: "Model",
    id: "vehicleName"
  },
  {
    label: "Model Year",
    id: "ModelYear"
  },
  {
    label: "Dispatch Model Type",
    id: "DispatchModelType"
  },
  {
    label: "No. VINs",
    id: 'MASKED-VIN_list'
  },
  {
    label: "Count of CAN Signal",
    id: "can_signals"
  },
  {
    label: "Count of 51F Signal",
    id: "51f_signals"
  },
  {
    label: "Start Date",
    id: "min_timestamp"
  },
  {
    label: "End Date",
    id: "max_timestamp"
  }
];

export const userDataSummaryLabels = [
  {
    label: "VIN COUNT",
    id: 'MASKED-VIN_list'
  },
  {
    label: "Start Date",
    id: "min_timestamp"
  },
  {
    label: "End Date",
    id: "max_timestamp"
  },
  {
    label: "Total Models",
    id: "vehicleName"
  },
  {
    label: "No. of Dispatch Model",
    id: "DispatchModelType"
  }
];

export const jobAuditTableHeader = [
  {
    label: "",
    id: 'accordion'
  },
  {
    label: "Job Id",
    id: "id"
  },
  {
    label: "Job Name",
    id: "job_name"
  },
  {
    label: "User Input",
    id: "user_inputs"
  },
  {
    label: "Status",
    id: "status"
  },
  {
    label: "Request Date/Time",
    id: 'requestDateAndTime'
  },
  {
    label: "Processing Time hh:mm:ss",
    id: "processedTime"
  },
  {
    label: "Actions",
    id: "actions"
  },
  {
    label: "",
    id: ""
  }
];

export const jobAuditSubJobTableHeader = [
  {
    label: "",
    id: 'accordion'
  },
  {
    label: "Job Type",
    id: 'jobType'
  },
  {
    label: "Job Name",
    id: "job_name"
  },
  {
    label: "Job Id",
    id: "id"
  },
  {
    label: "User Input",
    id: "user_inputs"
  },
  {
    label: "Status",
    id: "status"
  },
  {
    label: "Request Date/Time",
    id: 'requestDateAndTime'
  },
  {
    label: "Processing Time hh:mm:ss",
    id: "processedTime"
  },
  {
    label: "Actions",
    id: "actions"
  },
];

export const jobAuditSubSubJobTableHeader = [
  {
    label: "Job Type",
    id: 'jobType'
  },
  {
    label: "Job Id",
    id: "id"
  },
  {
    label: "User Input",
    id: "user_inputs"
  },
  {
    label: "Status",
    id: "status"
  },
  {
    label: "Request Date/Time",
    id: 'requestDateAndTime'
  },
  {
    label: "Processing Time hh:mm:ss",
    id: "processedTime"
  },
  {
    label: "Actions",
    id: "actions"
  },
];

export const jobAuditSubTableHeader = [
  {
    label: "Job Id",
    id: "id"
  },
  {
    label: "Job Name",
    id: "job_name"
  },
  {
    label: "Status",
    id: "status"
  },
  {
    label: "Request Date/Time",
    id: 'requestDateAndTime'
  },
  {
    label: "Processing Time hh:mm:ss",
    id: "processedTime"
  },
  {
    label: "Actions",
    id: "actions"
  }
];

export const AGGREGATIONDATALIST = [
  {
    label: 'By Month',
    value: 'By Month'
  },
  {
    label: 'By Date',
    value: 'By Date'
  },
  {
    label: 'By VIN',
    value: 'By Vin'
  },
  {
    label: 'By Time of Day',
    value: 'By Time'
  },
  {
    label: 'By Trip',
    value: 'By Trip'
  },
  {
    label: 'By Model',
    value: 'By DispatchModelType'
  },
  {
    label: 'By Model Year',
    value: 'By ModelYear'
  },
  {
    label: 'By Dispatch Model Type',
    value: 'By VehicleName'
  }
];

export const AGGREGATIONVALUELIST = [
  {
    label: 'Max',
    value: 'max'
  },
  {
    label: 'Min',
    value: 'min'
  },
  {
    label: 'Avg',
    value: 'avg'
  },
  {
    label: 'Std Deviation',
    value: 'stddev'
  },
  {
    label: 'Quartiles',
    value: 'quartiles'
  },
  {
    label: 'Discrete State of Time',
    value: 'discrete_state_of_time'
  },
  {
    label: 'Discrete Variables',
    value: 'discrete_variables'
  },
  {
    label: '% Input',
    value: 'perc_input'
  },
  {
    label: 'Discrete State (as a %)',
    value: 'discrete_state_as_perc'
  }
];


export const AGGREGATIONDATALISTAPI = [
  {
    label: 'By Month',
    value: 'month'
  },
  {
    label: 'By Date',
    value: 'date'
  },
  {
    label: 'By Vin',
    value: 'vin'
  },
  {
    label: 'By Time of Day',
    value: 'timeofday'
  },
  {
    label: 'By Model',
    value: 'DispatchModelType'
  },
  {
    label: 'By Model Year',
    value: 'modelYear'
  },
  {
    label: 'By Dispatch Model Type',
    value: 'vehicleName'
  }
];

export const AnalysisTypeList = [
  {
    id: 'histogram',
    label: 'HISTOGRAM'
  },
  {
    id: 'barchart',
    label: 'BAR CHART'
  },
  {
    id: 'timeseries',
    label: 'TIME SERIES'
  },
  {
    id: 'doubleplot',
    label: 'DOUBLE PLOT'
  },
  {
    id: 'quadplot',
    label: 'QUAD PLOT'
  },
  {
    id: 'heatmap',
    label: 'HEAT MAP'
  },
  {
    id: 'piechart',
    label: 'PIE CHART'
  },
  {
    id: 'scatterPlot',
    label: 'SCATTER PLOT'
  }
]

export const histogramColorList = [
  {
    item: 'rgb(241 193 196)',
    itemB: 'rgba(247, 39, 53, 1)'
  },
  {
    item: 'rgba(183, 178, 178, 1)',
    itemB: 'rgba(0,0,0,0.87)'
  },
  {
    item: 'rgb(161 188 167)',
    itemB: 'rgba(22, 101, 52, 1)'
  },
  {
    item: 'rgb(240 229 185)',
    itemB: 'rgba(250, 204, 21,0.87)'
  }
]

export const defaultTimeseriesVins = ['1ed6afb1-c94a-4b64-a75d-326de5c48486', '35927c6b-e345-4607-b2b0-3c7bdf2677fe', '43308702-af40-4ddf-ac92-bc11abb92095', '4eea7c87-9266-452d-bb93-5d7b16bb9b43'];

export const heatMapColorPalatte = [
  // Let first 10% (0.1) of the values have color rgb(0, 0, 0)
  [0, 'rgb(127, 29, 29)'],
  [0.1, 'rgb(127, 29, 29)'],

  // Let values between 10-20% of the min and max of z
  // have color rgb(20, 20, 20)
  [0.1, 'rgb(153, 27, 27)'],
  [0.2, 'rgb(153, 27, 27)'],

  // Values between 20-30% of the min and max of z 
  //have color rgb(40, 40, 40)
  [0.2, 'rgb(185, 28, 28)'],
  [0.3, 'rgb(185, 28, 28)'],

  [0.3, 'rgb(220, 38, 38)'],
  [0.4, 'rgb(220, 38, 38)'],

  [0.4, 'rgb(239, 68, 68)'],
  [0.5, 'rgb(239, 68, 68)'],

  [0.5, 'rgb(248, 113, 113)'],
  [0.6, 'rgb(248, 113, 113)'],

  [0.6, 'rgb(252, 165, 165)'],
  [0.7, 'rgb(252, 165, 165)'],

  [0.7, 'rgb(254, 202, 202)'],
  [0.8, 'rgb(254, 202, 202)'],

  [0.8, 'rgb(254, 226, 226)'],
  [0.9, 'rgb(254, 226, 226)'],

  [0.9, 'rgb(254, 242, 242)'],
  [1.0, 'rgb(254, 242, 242)']
];


export const SUMMARYSTATISTICSAGGREGATIONDATALIST = [
  {
    label: 'By VehicleName',
    value: 'vehicleName'
  },
  {
    label: 'By ModelYear',
    value: 'modelYear'
  },
  {
    label: 'By DispatchModelType',
    value: 'DispatchModelType'
  },
  {
    label: 'By Vin',
    value: 'vin'
  },
];

export const SUMMARYSTATISTICSAGGREGATIONVALUELIST = [
  {
    label: 'Max',
    value: 'max'
  },
  {
    label: 'Min',
    value: 'min'
  },
  {
    label: 'Avg',
    value: 'avg'
  },
  {
    label: 'Std Deviation',
    value: 'stddev'
  },
  {
    label: 'Quartiles',
    value: 'quartile'
  },
  {
    label: '95% input',
    value: 'perc_95'
  },
  {
    label: 'Null Count',
    value: 'null_count'
  },
];

export const AGGREGATIONVALUEEDISCRETEQUARTILEEXCLUDELIST = [
  {
    label: 'Max',
    value: 'max'
  },
  {
    label: 'Min',
    value: 'min'
  },
  {
    label: 'Avg',
    value: 'avg'
  },
  {
    label: 'Std Deviation',
    value: 'stddev'
  },
  {
    label: '% input',
    value: 'perc_input'
  },
];

export const AGGREGATIONVALUEEDISCRETEEXCLUDELIST = [
  {
    label: 'Max',
    value: 'max'
  },
  {
    label: 'Min',
    value: 'min'
  },
  {
    label: 'Avg',
    value: 'avg'
  },
  {
    label: 'Std Deviation',
    value: 'stddev'
  },
  {
    label: 'Quartiles',
    value: 'quartiles'
  },
  {
    label: '% input',
    value: 'perc_input'
  },
];


export const defaultSignalStatListData = {
  "AccelLR": { "max": 9.81, "min": 0 },
  "AccelFB": { "max": 9.81, "min": 0 },
  "EngineRPM": { "max": 7000, "min": 0 },
  "EstimatedMu": { "max": 1, "min": 0 },
  "EstimatedRoadGrade": { "max": 20, "min": 0 },
  "Speed": { "max": 160, "min": 0 },
  "WheelSpeedFL": { "max": 160, "min": 0 },
  "WheelSpeedFR": { "max": 160, "min": 0 },
  "WheelSpeedRL": { "max": 160, "min": 0 },
  "WheelSpeedRR": { "max": 160, "min": 0 },
  "TirePressureFL": { "max": 60 * 6.89475729, "min": 0 },
  "TirePressureFR": { "max": 60 * 6.89475729, "min": 0 },
  "TirePressureRL": { "max": 60 * 6.89475729, "min": 0 },
  "TirePressureRR": { "max": 60 * 6.89475729, "min": 0 },
  "AmbientTemp_A": { "max": 50, "min": -40 },
  "AmbientTemp_B": { "max": 50, "min": -40 },
  "BrakePedalPressure": { "min": 0 },
  "BrakeTorque": { "min": 0 },
  "ABSControl": { "min": 0, "max": 1 }
}

export const mapFilterList = [
  {
    id: 'speed',
    label: "Speed",
    value: 'speedList'
  },
  {
    id: 'state',
    label: "State",
    value: 'stateList'
  },
  {
    id: 'surface',
    label: "Surface",
    value: 'surfaceList'
  },
  {
    id: 'city',
    label: "City",
    value: 'cityList'
  },
  {
    id: 'zipcode',
    label: "Zipcode",
    value: 'zipcodeList'
  },
  {
    id: 'reset',
    label: "Reset Selection",
    value: 'resetSelection'
  }
]

export const speedList = [
  "20 mph",
  "25 mph",
  "30 mph",
  "35 mph",
  "40 mph",
  "45 mph",
  "50 mph",
  "55 mph",
  "60 mph",
  "65 mph",
  "70 mph",
  "75 mph",
  "80 mph",
  "85 mph",
  "90 mph",
  "95 mph",
]

export const surfaceList = ['unpaved', 'asphalt_with_concrete', 'mixed', 'concrete:plates', 'sett', 'partialy_paved', 'unhewn_cobblestone', '5', 'sand', 'bricks', 'asphalt', 'grass', 'earth', 'asphalt:lanes', 'cinder', 'concrete:lanes', 'clay', 'asphalt_with_brick', 'pebblestone', 'grass_paver', 'ground', 'asphalt,_concrete', 'chipseal', 'brick', 'asl', 'drive', 'paved', 'concrete_and_brick', 'woodchips', 'rubber', 'artificial_turf', 'gravel', 'tile', 'compacted', 'dirt/asphalt', 'metal', 'UN', '1', 'mud', 'service', 'yes', 'sign', 'fine_gravel', 'dirt;unpaved', 'dirt', 'gravel,_dirt', 'paving_stones', 'cobblestone', 'terrazzo', 'paved driveway', 'rock', 'wood', 'asphalt,paved', 'concrete', 'rocks', 'gravel,asphalt', 'dirt/gravel', 'asphalt,_unpaved', 'pavement_crumbling', 'concrete,_asphalt', '2', 'bark', 'paved parking lot', 'dirt/sand', 'aa', 'dirt;paved', 'cement', 'asphalt_(deteriorated)', 'soil', 'asphalt;concrete', 'ash', 'unpaved,_graveled', 'rivew', 'crushed_limestone', 'turf', 'pavers', 'gravel_/_paved', 'a\\', 'dirt,_mud,_sand', 'shells', 'Millet', 'paves', 'dirt, grass', 'gravel,_sand', 'partially_paved', 'both', 'asphalt,concrete', 'dirt;sand', 'metal_grid', 'bing', 'unpavedz', 'brik', 'w', 'pa', 'unpavedzz', 'unpavedw', 'unpprivate', '20', 'fallen_trees', 'd', 'dirt,_creeks,_mud', 'acrylic', 'Mud,_Creek', 'no', 'Creek,_Dirt,_rocky,Mud', 'asphalt,_dirt', 'gravel/asphalt', 'concrete;asphalt', 'cobblestone:flattened', 'paved;unpaved', 'ashpalt', 'gra', 'culvert', 'hard', 'traffic_signals', 'grass,_dirt,_asphalt', 'gracel', '45', 'track', 'baved', 'paved2', 'shell_chips', 'Shells', 'bitmac', 'block', 'shell', 'gravel,_half-paved', '4', 'plastic', 'plywood_over_unknown', 'crushed_shells', 'stone', 'o', 'asphaltf', 'Wimpies_Road', 'rocky', '13', 'up', 'unpaved2', 'plastic_grid', 'porous', 'millings', 'gravelq', '70', 'z', 'dirt;clay', 'gravel/dirt', 'Path', 'gravel,_asphalt', 'dirt,_sand,_clay', 'gravel_and_asphalt', 'gravel,concrete', 'unpaved;clay', 'fine_gr', 'water', "'", 'as\\', 'blacktop', 'construction', 'asphalt_/_gravel', 'broken_asphalt', 'paving_stones:30', 'compact', 'ice', 'mulch', 'steel_mesh', 'unpaved;paved', 'grave3', 'some_paved,_some_unpaved', 'U6', 'Bing', 'primitive', 'loose_shale', 'unpaved;gravel', 'macadam', 'gravel;ground', 'dirt,_rock,_sand', 'dire', 'building_passage', 'gravel3', 'unn', 'concrete; asphalt', 'Crusher_Fines', 'driveway', 'dirt;asphalt', 'parking', '3', 'un4', 'asphalt;concrete;gravel', 'wood_plank', 'partially_unpaved', 'asphalt;gravel', 'gruond', 'asphalt;unpaved', 'alley']